export default __webpack_public_path__ + "static/kerner-de63a69eb2d71cfe86ecbcf7ce375a90.png";